import { createSlice } from "@reduxjs/toolkit";
import * as actions from './api';

export const dashboardSlice = createSlice({
    name: "dashboard",
    initialState: {
        loading: false,
        error: null,
        subscription_count: 0,
        app_count: 0,
        popup: false,
    },
    reducers: {
        dashboardRequested: (state, action) => {
            state.loading = true;
        },
        statReceived: (state, action) => {
            state.loading = false;
            state.subscriptionCount = action.payload.subscription_count;
        },
        dashboardError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    }
});

const {
    dashboardRequested,
    statReceived,
    dashboardError
} = dashboardSlice.actions;

const getStat = (appId) => (dispatch, getState) => {
    const accessToken = getState().auth.accessToken;
    dispatch(
        actions.apiCallBegan(
            {
                url: `/adm/dashboard?app_id=${appId}`,
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + accessToken
                },
                onStart: dashboardRequested.type,
                onSuccess: statReceived.type,
                onError: dashboardError.type
            }
        )
    );
}

export { getStat };

export default dashboardSlice.reducer;

